export default __webpack_public_path__ + "static/media/theYoungLadiesOfAvignon.6260f7e9.jpg";